import { connect } from "react-redux";

import type { OwnProps as TicketOptionsProps } from "@app/modules/ticket-options/ticket-options.connect";
import { mapStateToProps } from "@app/modules/ticket-options/ticket-options.connect";

import type { ConnectedProps } from "react-redux";

import { SelectionOptions as SelectionOptionsComponent } from "./selection-options";

type OwnProps = TicketOptionsProps & {
  onClose: () => void;
};

const connector = connect(mapStateToProps);

export type ConnectorProps = ConnectedProps<typeof connector> & OwnProps;

export const SelectionOptions = connector(SelectionOptionsComponent);
